<script setup>
import WebApp from "@twa-dev/sdk";
const exitWebApp = () => {
	WebApp.close();
};
</script>
<template>
    <button @click="exitWebApp" class="btn">Закрыть</button>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
</style>